import { AuthStore } from "stores/AuthStore";
import RootStore from "stores/RootStore";

export interface DevelopmentAccessOptions {
    requireUltraUser?: boolean;
}

export function isDevelopmentEnvironment(): boolean {
    return process.env.NODE_ENV === "development";
}

export function canAccessDevelopmentOnlyFeatures(
    options: DevelopmentAccessOptions = {},
): boolean {
    if (!isDevelopmentEnvironment()) {
        return false;
    }

    if (!options.requireUltraUser) {
        return true;
    }

    const rootStore = RootStore();
    const authStore = rootStore.getStore(AuthStore);
    return authStore.isUserUltra();
}
